/* eslint-disable @typescript-eslint/camelcase */
import React, { useContext } from 'react';
import {
  formatText,
  getColorGradientClassByRating
} from '../../utils/stringUtils';
import { Context } from '../../AppContext';
import { NEW, NO_RATINGS } from '../../constants/miscellaneousConstants';

export const RouteCabsFareCards = ({ cabPackage, idx }) => {
  const {
    package_title,
    cab_description,
    strike_off_discount_text,
    strike_off_discount,
    inclusive_message,
    overall_rating,
    rating_count,
    rating_show,
    total_inclusive_amount,
    persuasions,
    desktop_claim_persuasions,
    type,
    reviewURL
  } = cabPackage;

  const { omniUrlArgs, trackTemplateEvent } = useContext(Context);
  const redirect = (url: string) => {
    if (!url) return;
    const rediectionUrl = `${url}&${omniUrlArgs}`;
    // For webview Implementation as Saurav

    window.location = Object(rediectionUrl);
  };
  return (
    <div className="packageCard">
      <div className="makeFlex top spaceBetween">
        <div className="pushLeft">
          <div className="makeFlex hrtlCenter">
            <span className="recBlock"></span>
            <p className="latoBold font18 appendBottom5 appendRight10 makeFlex vrtlCenter ">
              {package_title &&
                package_title.map(({ title_word, superscript_text }, idx) => {
                  return (
                    <>
                      {title_word ? (
                        <span className={`${idx > 0 ? 'appendLeft5' : ''}`}>
                          {title_word}
                        </span>
                      ) : null}
                      {superscript_text ? (
                        <span style={{ marginTop: '-5px' }}>
                          {superscript_text}
                        </span>
                      ) : null}
                    </>
                  );
                })}
            </p>
            <span>
              {overall_rating && rating_show ? (
                <span
                  className={`${getColorGradientClassByRating(
                    overall_rating
                  )} ratingBoxV2`}
                >
                  <span className={`latoBlack whiteText lineHeight18 font14`}>
                    {overall_rating}/
                  </span>
                  <span className={`whiteText lineHeight18 font11`}>5</span>
                </span>
              ) : (
                <span
                  className={`ratingBox paddingT2 paddingB2 whiteText paddingL2 paddingR4 appendRight5 font14 latoBlack appendBottom3`}
                >
                  {NEW}
                </span>
              )}
            </span>
            <span>
              {rating_count && rating_show ? (
                <span
                  className={`appendLeft5 font12 lineHeight14 lightGreyText`}
                >
                  {rating_count} ratings
                </span>
              ) : (
                <span
                  className={`appendLeft5 font12 lineHeight14 lightGreyText`}
                >
                  {NO_RATINGS}
                </span>
              )}
            </span>
          </div>
          <div className="appendLeft24 appendRight5 appendBottom5 appendTop5 cabDescriptionCard">
            <span className="font14 latoRegular inclusiveMsg">
              {cab_description}
            </span>
          </div>
        </div>
        <div className="pushRight">
          <div>
            <div className="pushRightBottom redText pushRight strikeoffDiscount">
              {strike_off_discount_text ? (
                <span>{strike_off_discount_text}</span>
              ) : null}
            </div>
            <div className={`pushRightBottom pushRight`}>
              <span
                className={`strikeDiagonal font12 lightGreyText latoRegular appendRight10 pushBottom`}
              >
                {strike_off_discount
                  ? `₹ ${strike_off_discount + total_inclusive_amount}`
                  : ``}
              </span>
              <span className={`latoBlack font20`}>
                {total_inclusive_amount ? `₹ ${total_inclusive_amount}` : ``}
              </span>
            </div>
            <div>
              <p className="font10 pushRightBottom appendBottom5 inclusiveMsg">
                {inclusive_message}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="appendTop15 appendLeft10  makeFlex spaceBetween">
        <div className="fullWidth">
          {persuasions &&
            persuasions.map(persuasion => {
              const {
                title,
                icon_url,
                text,
                highlighted_text,
                highlight_color,
                tooltip_icon
              } = persuasion;
              return (
                <div className="makeFlex appendBottom10 ">
                  <div>
                    <img
                      className="appendRight5 checkBoxDimensionRouteCabsV2 lazyload"
                      alt={`${title}-image`}
                      data-src={icon_url}
                    ></img>
                  </div>
                  <div className="font14 latoBold blackText cabCardInfoPersuasionTitle">
                    {title}
                  </div>
                  <div style={{ width: '60%' }}>
                    {formatText({
                      text,
                      classNameForToolTipIcon: 'appendLeft5 toolTipIcon',
                      highlightedText: highlighted_text,
                      highlightedColor: highlight_color,
                      classNameForNonHighightedText: 'blackText',
                      className: 'latoBold blackText',
                      tooltipIcon: tooltip_icon,
                      idx
                    }).map(val => val)}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      <div>
        <div
          className={`makeFlex justifyCenter  alignFlexEnd alignCenter appendBottom5 appendLeft10`}
        >
          <span className={`dottedHorizontalLine`}></span>
          <a href={reviewURL} className="alignFlexEnd appendLeft5">
            <span
              onClick={e => {
                trackTemplateEvent(
                  `Cab_SEO_Route_${type}_Book_Isomorph_Cab_Package_Click`
                );
                e.preventDefault();
                redirect(reviewURL);
              }}
              className="bookButton"
            >
              BOOK
            </span>
          </a>
        </div>
      </div>
      <div>
        <div className="appendLeft10">
          {desktop_claim_persuasions &&
            desktop_claim_persuasions.map(persuasion => {
              const {
                title,
                icon_url,
                text,
                highlighted_text,
                highlight_color,
                tooltip_icon
              } = persuasion;
              return (
                <div className="makeFlex appendBottom10">
                  <div className="appendRight10">
                    <img
                      className="checkBoxDimensionRouteCabsV2 lazyload"
                      alt={`${title}-image`}
                      data-src={icon_url}
                    ></img>
                  </div>
                  <div>
                    {formatText({
                      text,
                      classNameForToolTipIcon: 'apendLeft5 toolTipIcon',
                      highlightedText: highlighted_text,
                      highlightedColor: highlight_color,
                      classNameForNonHighightedText: 'blackText',
                      className: 'latoBold blackText',
                      tooltipIcon: tooltip_icon,
                      idx
                    }).map(val => val)}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};
